export const cuboidShapeTypeIcon = {
  name: 'cuboid-shape-type',
  svg: `<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0792 1.63069C11.4675 1.40879 11.9443 1.40879 12.3326 1.63069L20.7693 6.45164C20.966 6.56408 21.0875 6.77335 21.0875 7V16.6335C21.0875 17.0868 20.8446 17.5053 20.451 17.7302L12.0193 22.5484C11.8251 22.6593 11.5867 22.6593 11.3926 22.5484L2.9608 17.7302C2.56723 17.5053 2.32434 17.0868 2.32434 16.6335V7C2.32434 6.77335 2.44578 6.56408 2.64257 6.45164L11.0792 1.63069ZM19.1829 7L11.7059 2.72742L4.22891 7L11.7059 11.2726L19.1829 7ZM19.8243 8.08832L12.3375 12.3665V20.9117L19.8243 16.6335V8.08832ZM11.0743 20.9117V12.3665L3.5875 8.08832V16.6335L11.0743 20.9117Z"
    />
  </svg>`,
};
